import { FC } from 'react'
import { AtendimentoView } from '../../../atendimento/core/_models'
import { FetchState, useModal } from '../../../../../components'
import { DiagnosticoForm } from './DiagnosticoForm'

/** Situação diagnóstica e CIDs do atendimento, em modal (tela de teleatendimento). */
export const CIDModal: FC = () => {
  const { fetchStates, closeModal, refetch } = useModal()
  const { data: atendimento } = (fetchStates['atendimento'] || {}) as FetchState<AtendimentoView>

  return (
    <DiagnosticoForm
      atendimento={atendimento}
      onAtualizar={() => refetch('atendimento')}
      onFechar={closeModal}
    />
  )
}
